import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import { batch, connect } from 'react-redux';
import GeoSearch, { GeoSearchSelection } from '@sbt-web/geo-search';
import { useViewport } from '@sbt-web/hooks';
import { CategoryID, FilterURI, GeoEntry } from '@sbt-web/network/types';
import type { RootState } from '@/reducers/index';
import { RadiusSearch, setRadiusDialogStatus, updateGeo, updateRadiusSearch } from '@/reducers/search';
import { setPreventPopstate } from '@/reducers/system';
import { MOBILE_API_CHANNEL, WEB_API_CHANNEL } from '@/shared/constants';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import '@sbt-web/geo-search/dist/index.css';
interface OwnProps {
  geoLimit?: number;
}
interface StateProps {
  geo: GeoEntry;
  searchNearRegions?: boolean;
  radiusSearch?: RadiusSearch;
  totalItems: number;
  isImmobili: boolean;
}
interface DispatchProps {
  updateGeo: (geo: GeoEntry, snr?: boolean) => void;
  updateRadiusPreview: (radiusSearch: RadiusSearch) => void;
  updateRadiusSearch: (radiusSearch: RadiusSearch) => void;
  updateRadiusDialogStatus: (isOpen: boolean) => void;
}
type Props = OwnProps & StateProps & DispatchProps;
export function QueryGeoComponent(t0) {
  const $ = _c(27);
  const {
    geo,
    searchNearRegions,
    geoLimit,
    updateGeo,
    updateRadiusPreview,
    updateRadiusSearch,
    updateRadiusDialogStatus,
    radiusSearch,
    totalItems,
    isImmobili
  } = t0;
  const {
    isMobile
  } = useViewport();
  const isRadiusEnabled = isMobile && isImmobili;
  let t1;
  if ($[0] !== updateRadiusDialogStatus) {
    t1 = () => {
      updateRadiusDialogStatus(true);
    };
    $[0] = updateRadiusDialogStatus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const signalDialogOpening = t1;
  let t2;
  if (radiusSearch != null) {
    let t3;
    if ($[2] !== radiusSearch.addressToTrack || $[3] !== radiusSearch.center || $[4] !== radiusSearch.friendlyName) {
      t3 = {
        point: radiusSearch.center,
        friendlyName: radiusSearch.friendlyName,
        addressToTrack: radiusSearch.addressToTrack
      };
      $[2] = radiusSearch.addressToTrack;
      $[3] = radiusSearch.center;
      $[4] = radiusSearch.friendlyName;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== radiusSearch.radiusMeters || $[7] !== t3) {
      t4 = {
        entry: t3,
        radius: radiusSearch.radiusMeters,
        responseFrom: "here"
      };
      $[6] = radiusSearch.radiusMeters;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t2 = t4;
  } else {
    const t3 = searchNearRegions ?? false;
    let t4;
    if ($[9] !== geo || $[10] !== t3) {
      t4 = {
        entry: geo,
        searchNearRegions: t3,
        responseFrom: "geogos"
      };
      $[9] = geo;
      $[10] = t3;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t2 = t4;
  }
  const startingValue = t2;
  let t3;
  if ($[12] !== updateRadiusPreview) {
    t3 = selection => {
      if (selection.responseFrom === "geogos") {
        return;
      } else {
        if (selection.responseFrom === "here") {
          updateRadiusPreview({
            radiusMeters: selection.radius,
            center: selection.entry.point,
            friendlyName: selection.entry.friendlyName
          });
        }
      }
    };
    $[12] = updateRadiusPreview;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const updateResultsPreview = t3;
  let t4;
  if ($[14] !== updateGeo || $[15] !== updateRadiusSearch) {
    t4 = selection_0 => {
      if (selection_0.responseFrom === "geogos") {
        updateGeo(selection_0.entry, selection_0.searchNearRegions);
      } else {
        if (selection_0.responseFrom === "here") {
          updateRadiusSearch({
            radiusMeters: selection_0.radius,
            center: selection_0.entry.point,
            addressToTrack: selection_0.entry.addressToTrack,
            friendlyName: selection_0.entry.friendlyName
          });
        }
      }
    };
    $[14] = updateGeo;
    $[15] = updateRadiusSearch;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const handleSelection = t4;
  const t5 = isRadiusEnabled ? "radius" : "base";
  const t6 = isMobile ? MOBILE_API_CHANNEL : WEB_API_CHANNEL;
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = getOrCreatePulse();
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== geoLimit || $[19] !== handleSelection || $[20] !== signalDialogOpening || $[21] !== startingValue || $[22] !== t5 || $[23] !== t6 || $[24] !== totalItems || $[25] !== updateResultsPreview) {
    t8 = <GeoSearch variant={t5} hereApiKey={process.env.NEXT_PUBLIC_HERE_WEB_KEY} assetsBase={process.env.NEXT_PUBLIC_ASSETS_BASE_URL} channel={t6} hadesBasePath={process.env.NEXT_PUBLIC_HADES_BASE_URL} value={startingValue} name={FilterURI.Geo} onDialogOpen={signalDialogOpening} onSelect={handleSelection} resultsLimit={geoLimit} pulseInstance={t7} resultsPreview={totalItems} updateResultsPreview={updateResultsPreview} />;
    $[18] = geoLimit;
    $[19] = handleSelection;
    $[20] = signalDialogOpening;
    $[21] = startingValue;
    $[22] = t5;
    $[23] = t6;
    $[24] = totalItems;
    $[25] = updateResultsPreview;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}
const immobiliCategoryIds: CategoryID[] = [CategoryID.Immobili, CategoryID.Appartamenti, CategoryID.CamerePostiLetto, CategoryID.Ville, CategoryID.TerreniRustici, CategoryID.GarageBox, CategoryID.LoftMansarde, CategoryID.UfficiLocali];
export const QueryGeoInput = connect<StateProps, DispatchProps, unknown, RootState>(state => ({
  geo: state.search.geo,
  searchNearRegions: state.search.searchNearRegions,
  radiusSearch: state.search.radiusSearch as RadiusSearch | undefined,
  totalItems: state.items.total,
  isImmobili: immobiliCategoryIds.includes(state.search.category.id)
}), dispatch => ({
  updateGeo: (geo: GeoEntry, snr?: boolean) => {
    batch(() => {
      dispatch(setPreventPopstate(false));
      dispatch(setRadiusDialogStatus(false));
      dispatch(updateGeo(geo, snr));
    });
  },
  updateRadiusPreview: (radiusSearch: RadiusSearch) => {
    dispatch(updateRadiusSearch({
      radiusSearch,
      isFinalSearch: false
    }));
  },
  updateRadiusSearch: (radiusSearch: RadiusSearch) => {
    batch(() => {
      dispatch(setPreventPopstate(false));
      dispatch(setRadiusDialogStatus(false));
      dispatch(updateRadiusSearch({
        radiusSearch,
        isFinalSearch: true
      }));
    });
  },
  updateRadiusDialogStatus: (isOpen: boolean) => {
    batch(() => {
      dispatch(setPreventPopstate(isOpen));
      dispatch(setRadiusDialogStatus(isOpen));
    });
  }
}))(QueryGeoComponent);